import React, { Component } from 'react';

import { Button } from 'semantic-ui-react';

export default class FullScreenButton extends Component {
  state = {
    hover: false
  };

  render() {
    const props = this.props;
    const buttonProps = {
      icon: this.props.fullscreen ? 'compress' : 'expand',
      style: this.state.hover
        ? { ...styles.button, ...styles.buttonHover }
        : { ...styles.button }
    };
    return (
      <div style={styles.container}>
        <Button
          compact
          secondary
          size="massive"
          {...buttonProps}
          onClick={() => props.onChangeFullscreen(!this.props.fullscreen)}
          onMouseEnter={() => this.setState({ hover: true })}
          onMouseLeave={() => this.setState({ hover: false })}
        />
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'absolute',
    right: 8,
    top: 20,
    padding: 10,
    overflow: 'visible'
    // paddingLeft: 3
  },
  button: {
    borderRadius: 5,
    padding: 15
  },
  buttonHover: {}
};



// WEBPACK FOOTER //
// ./src/components/FullScreenButton.js